import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import MainLayout from './layouts/MainLayout';
import HomeView from './views/HomeView';
import HistoryView from './components/HistoryView';
import BookmarksView from './components/BookmarksView';
import CategoryGrid from './components/CategoryGrid';
import Dashboard from './pages/Dashboard';
import PlaceDetailsModal from './components/PlaceDetailsModal';
import { checkVersionAndClearCache } from './services/geoService';
import { trackClick } from './utils/analytics';

function App() {
  const [location, setLocation] = useState(null);
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [selectedPlace, setSelectedPlace] = useState(null);
  
  // Initialize state from local storage safely
  const [bookmarks, setBookmarks] = useState(() => {
    try {
      const saved = localStorage.getItem('nearme_bookmarks');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });

  const [history, setHistory] = useState(() => {
    try {
      const saved = localStorage.getItem('nearme_history');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });

  useEffect(() => {
    checkVersionAndClearCache();
  }, []);

  useEffect(() => {
    localStorage.setItem('nearme_bookmarks', JSON.stringify(bookmarks));
  }, [bookmarks]);

  useEffect(() => {
    localStorage.setItem('nearme_history', JSON.stringify(history));
  }, [history]);

  const handleSelectHistory = (item) => {
    trackClick('Select History Item', 'History');
    setLocation({ lat: item.lat, lng: item.lng });
    setAddress(item.address);
    setCity(item.city);
    setCountryCode(item.countryCode);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<MainLayout bookmarkCount={bookmarks.length} />}>
          <Route index element={
            <HomeView 
              location={location} setLocation={setLocation}
              address={address} setAddress={setAddress}
              city={city} setCity={setCity}
              countryCode={countryCode} setCountryCode={setCountryCode}
              bookmarks={bookmarks} setBookmarks={setBookmarks}
              setHistory={setHistory}
              setSelectedPlace={setSelectedPlace}
            />
          } />
          <Route path="history" element={
            <HistoryView 
              history={history} 
              onRemove={(id) => id === 'all' ? setHistory([]) : setHistory(prev => prev.filter(h => h.id !== id))}
              onSelectHistory={handleSelectHistory}
              onNavigate={(lat, lng) => window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`, '_blank')}
            />
          } />
          <Route path="bookmarks" element={
            <BookmarksView 
              bookmarks={bookmarks} 
              onRemove={(id) => setBookmarks(prev => prev.filter(b => b.id !== id))}
              onNavigate={(lat, lng) => window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`, '_blank')}
            />
          } />
          <Route path="explore" element={<CategoryGrid onSearch={() => {}} />} />
        </Route>
        
        {/* Summary Dashboard Route */}
        <Route path="/dash" element={<Dashboard />} />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <AnimatePresence>
        {selectedPlace && (
          <PlaceDetailsModal 
            place={selectedPlace} 
            onClose={() => setSelectedPlace(null)} 
          />
        )}
      </AnimatePresence>
    </HashRouter>
  );
}

export default App;